import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const OutOfStockWarningElementChild = styled.div``;

export const OutOfStockWarningElementContainer = styled.div`
	${() => css`
		pointer-events: none;

		${OutOfStockWarningElementChild} {
			position: absolute;
			display: flex;
			flex-direction: column;
			transform: translate(-50%, -100%);
			justify-content: center;
			align-items: center;
			gap: 12px;
		}
	`}
`;
